export default __webpack_public_path__ + "static/media/forestly-expl-dissect-07_DE.184f2c5c.png";